import { createAction } from "@reduxjs/toolkit";
export const startLoad = createAction("app/startLoad");
export const stopLoad = createAction("app/stopLoad");
export const setError = createAction("app/setError");
